"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxTable = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _BulkPrice = require("b2b-components/core/components/ProductList/ProductBox/common/BulkPrice");
var _BasePrice = require("b2b-components/theme/components/BasePrice");
var _Price = require("b2b-components/theme/components/Price");
var _StockCount = require("b2b-components/theme/components/StockCount");
var _device = require("b2b-components/utils/device");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _Actions = require("../common/Features/Actions");
var _ImageLink = require("../common/ImageLink");
var _Title = require("../common/Title");
require("./ProductBoxTable.scss");
const ProductBoxTable = _ref => {
  let {
    basePrice,
    className,
    directDelivery = false,
    imageUrl,
    manufacturerSku,
    onProductClick,
    price,
    sku,
    renderSku,
    stock,
    title,
    dataAttributes,
    deviceType = _device.DEVICE_TYPE.desktop,
    isSpecialOrder = false,
    renderActions = null,
    renderHiddenPrice = null,
    text = {
      sku: 'SKU',
      manufacturerSku: 'Manufacturer SKU',
      category: 'Category',
      variants: 'Also available in:',
      new: 'new',
      promotion: 'promotion',
      sellout: 'sellout',
      occasion: 'occasion',
      coreAssortment: 'Core Assortment',
      ownAssortment: 'Customer specific assortment',
      consciousAlternative: 'Conscious alternative',
      stockCount: {
        date: 'Date',
        deliveryDates: 'Expected delivery date',
        notReadyForShipment: 'Not ready for shipment',
        orderedQuantity: 'Ordered Quantity',
        readyForShipment: 'pc. ready for shipment',
        readyForDirectDelivery: 'pc. ready for direct delivery',
        unknownDeliveryDate: 'Unknown delivery date',
        specialOrder: {
          full: 'Special Order',
          short: 'S.O.',
          explanation: 'We do not stock this item.'
        },
        seeMore: 'see more',
        deliveryInfoPackage: 'This item ships in a separate package, directly from our supplier.',
        deliveryInfoTime: 'Delivery time is 3 to 5 business days.',
        directDeliveryStockInfo: 'stock in supplier’s warehouse'
      },
      bulkPrice: {
        buy: 'Buy',
        bulkPricing: 'Bulk pricing'
      }
    },
    url = '#',
    quantityOrdered = null,
    bulkPrices
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-ProductBoxTable-BodyRow', className);
  return /*#__PURE__*/_react.default.createElement("tr", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react.default.createElement(_ImageLink.ImageLink, {
    sku: sku,
    url: url,
    title: title,
    imageUrl: imageUrl,
    onClick: onProductClick
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-ProductBox-ProductSKU"
  }, renderSku?.(sku) || sku)), /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-ProductBox-ManufacturerSKU"
  }, renderSku?.(manufacturerSku) || manufacturerSku)), /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react.default.createElement(_Title.Title, {
    sku: sku,
    url: url,
    title: title,
    className: "cds-ProductBoxTable-Text cds-ProductBoxTable-Title",
    onClick: onProductClick
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBoxTable-BodyCell cds-ProductBoxTable-BodyCell--Price"
  }, renderHiddenPrice, !renderHiddenPrice && /*#__PURE__*/_react.default.createElement(_Price.Price, {
    price: price,
    size: _Price.PRICE_SIZE.small
  }), basePrice && /*#__PURE__*/_react.default.createElement(_BasePrice.BasePrice, {
    unit: basePrice.unit,
    price: basePrice.price
  }), /*#__PURE__*/_react.default.createElement(_BulkPrice.BulkPrice, {
    bulkPrice: bulkPrices || [],
    text: text.bulkPrice,
    className: "cds-ProductBoxTable-BulkPrice"
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBoxTable-BodyCell cds-ProductBoxTable-BodyCell--Stock"
  }, /*#__PURE__*/_react.default.createElement(_StockCount.StockCount, {
    className: "cds-ProductBox-StockCount",
    deviceType: deviceType,
    isSpecialOrder: isSpecialOrder,
    quantityOrdered: quantityOrdered,
    stockCount: stock,
    text: text.stockCount,
    directDelivery: directDelivery
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: "cds-ProductBoxTable-BodyCell"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ProductBoxTable-BodyCellDimensionsHolder"
  }), !!renderActions && /*#__PURE__*/_react.default.createElement(_Actions.Actions, null, renderActions)));
};
exports.ProductBoxTable = ProductBoxTable;
//# sourceMappingURL=ProductBoxTable.js.map